import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';
import React, { useMemo } from 'react';
import type { ColorValue } from 'react-native';

export const BrandIconTodayShipping: React.FC<{
  color: ColorValue;
  width?: number;
  height?: number;
}> = props => {
  const color = useMemo(() => {
    // return !props.selected ? ColorValues.lilac40 : ColorValues.white;
    return props.color;
  }, [props]);
  return (
    <Svg
      {...props}
      width={props.width ?? 49}
      height={props.height ?? 14}
      viewBox="0 0 49 14"
      fill="none"
    >
      <G clipPath="url(#clip0_30137_31500)" {...props}>
        <Path
          d="M30.4121 1.90725H26.7071L26.3369 3.28852H29.7949C29.0182 4.00427 27.3938 4.29308 25.8983 4.34331L25.5282 5.72459C27.404 5.6618 29.2301 5.34788 30.6361 4.41866C31.535 5.28509 33.1924 5.64924 35.0442 5.72459L35.4143 4.34331C33.9881 4.28053 32.5253 3.9666 32.0959 3.28852H35.5669L35.9371 1.90725H32.1931L32.442 0.978027H30.661L30.4121 1.90725Z"
          fill={color}
        />
        <Path
          d="M28.961 7.41979L28.8129 7.9723H25.0819L24.7219 9.3159H32.1709L32.033 9.83074H24.584L23.726 13.0328H33.229L33.5924 11.6766H25.8704L26.0083 11.1618H33.4573L34.3119 7.9723H30.5679L30.716 7.41979H35.214L35.5908 6.0134H24.8528L24.476 7.41979H28.961Z"
          fill={color}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M41.9695 1.51801L41.596 2.91184H39.139L39.5125 1.51801H37.7705L36.3136 6.95521H42.2546L43.7115 1.51801H41.9695ZM38.7655 4.30567H41.2225L40.8861 5.56138H38.4291L38.7655 4.30567Z"
          fill={color}
        />
        <Path
          d="M48.3857 3.57736H46.7347L47.3235 1.37988H45.5425L44.0082 7.10589H45.7892L46.3309 5.08421H47.9819L48.3857 3.57736Z"
          fill={color}
        />
        <Path
          d="M44.7176 11.639H37.4766L37.6415 11.0237H44.7395L45.6446 7.64584H36.7655L36.3954 9.02712H43.4934L43.3252 9.65497H36.2272L35.3221 13.0328H44.3441L44.7176 11.639Z"
          fill={color}
        />
        <Path
          d="M16.6077 3.40152H24.1347L23.7477 4.84558H14.4397L15.3515 1.44263H17.1325L16.6077 3.40152Z"
          fill={color}
        />
        <Path
          d="M13.4906 5.57389H24.2286L23.845 7.00539H13.107L13.4906 5.57389Z"
          fill={color}
        />
        <Path
          d="M14.4005 11.6389H22.1225L21.749 13.0328H12.246L13.1477 9.66749H20.5967L20.7515 9.08986H13.3025L13.6726 7.70859H22.9026L22.011 11.0362H14.562L14.4005 11.6389Z"
          fill={color}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6515 7.4827C11.5603 6.90508 12.2244 6.07631 12.5205 4.97129C12.8199 3.85372 12.5966 3.03751 11.9974 2.45989C11.2951 1.78181 10.0566 1.45532 8.49658 1.45532C6.93658 1.45532 5.5361 1.78181 4.45741 2.45989C3.54863 3.03751 2.88793 3.85372 2.58848 4.97129C2.29239 6.07631 2.51232 6.90508 3.11155 7.4827C3.69487 8.02265 4.59875 8.33658 5.75483 8.43703L5.092 10.9108H0.645999L0.245605 12.4051H10.8536L11.254 10.9108H6.86L7.52283 8.43703C8.71975 8.33658 9.79187 8.02265 10.6515 7.4827ZM10.4596 3.59002C10.7881 3.9165 10.9043 4.356 10.7395 4.97129C10.578 5.57403 10.2262 6.01353 9.72273 6.34001C9.03297 6.77951 8.0725 6.96786 7.0195 6.96786C5.9665 6.96786 5.10697 6.77951 4.65273 6.34001C4.32421 6.01353 4.20797 5.57403 4.36948 4.97129C4.53434 4.356 4.88611 3.9165 5.38959 3.59002C6.07935 3.15052 7.03982 2.96217 8.09282 2.96217C9.14582 2.96217 10.0054 3.15052 10.4596 3.59002Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_30137_31500">
          <Rect
            width="49"
            height="13"
            fill={color}
            transform="translate(0 0.5)"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
